import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchContractDependencies } from '../../../actions/admin/models/contracts';
import SelectField from '../../../components/forms/SelectField';
import { CONTRACT_STATE_OPTIONS, VALUE_ALL } from '../../../constants/settings';
import { toSelectionFormat } from '../../../lib/collection.utils';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import {
    fetchedDependenciesSelector,
    fetchingDependenciesSelector,
    dependenciesSelector
} from '../../../selectors/admin/forms';
import { filtersSelector } from '../../../selectors/admin/tables';
import { getContractFilter, storeContractFilter } from '../../../services/local.storage';

class ContractsAdvancedSearch extends Component {
    componentDidMount() {
        this._fetchDependencies();
        if (getContractFilter('event')) {
            // Only load back event filter, status filter is saved but not remembered.
            this._updateAndRememberFilter(getContractFilter('event'), 'event');
        }
    }
    componentDidUpdate() {
        this._fetchDependencies();
    }
    _fetchDependencies() {
        if (!this.props.fetchedDependencies && !this.props.fetchingDependencies) {
            this.props.fetchContractDependencies(this.props.contextId, null);
        }
    }
    _updateAndRememberFilter = (value, name) => {
        storeContractFilter(name, value);
        this.props.updateFilter(value, name);
    };
    render() {
        const { filters = {} } = this.props;
        return (
            <div className="ckp-admin-search-form ckp-grid-row">
                <SelectField
                    onChange={this._updateAndRememberFilter}
                    className="u-margin-right-3"
                    label="Status"
                    name="status"
                    items={CONTRACT_STATE_OPTIONS}
                    value={filters.status || ''}
                />
                <SelectField
                    onChange={this._updateAndRememberFilter}
                    className="u-margin-right-3"
                    label="Event"
                    name="event"
                    items={[
                        { value: VALUE_ALL, label: 'All events' },
                        ...toSelectionFormat(this.props.dependencies.events)
                    ]}
                    value={filters.event || ''}
                />
                <p className="ckp-admin-search-form-total">
                    <label className="u-italic u-margin-right-1 u-inline-block">Total:</label>
                    <span className="u-bold u-color-blue u-inline">{this.props.total}</span>
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    contextId: contextSubjectSelector(state),
    dependencies: dependenciesSelector(state),
    filters: filtersSelector(state),
    fetchedDependencies: fetchedDependenciesSelector(state),
    fetchingDependencies: fetchingDependenciesSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchContractDependencies }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContractsAdvancedSearch);
